import React, { memo, useCallback, useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import MultiSectionSorter from './multiSectionSorter';
import { useMultiSection } from 'src/hooks/useMultiSection';
import './multiSectionModule.scss';
import { Loading } from '@components';
import { IntegrationHub } from '../../modules/projects/projectDetail/hub/index';
import { useSelector } from 'react-redux';
import { projectRole } from '@model';
import { useDispatch } from 'react-redux';
import actions from '@flux/action';

function MultiSectionModule(props) {
  const history = useHistory();
  const isInternal = JSON.parse(
    window.localStorage.userInfo || '{}',
  ).isInternal;
  const currentUserPermission = useSelector(
    (state) => state.common.projectCompanyInfo.currentUserPermission,
  );
  const isContributor = currentUserPermission === projectRole.Contributor;
  const newRoutes = useSelector((state) => state?.common?.newRoutes);

  const [sectionSorterRefresher, setSectionSorterRefresher] = useState();
  const [isSettingModalShow, toggleSettingModalShow] = useState(false);
  const [activeSectionInModal, setActiveSectionInModal] = useState(null);
  const refresh = () => setSectionSorterRefresher((b) => !b);
  const [modalLoading, setModalLoading] = useState(false);
  const dispatch = useDispatch();

  const url = history.location?.search;
  const param = new URLSearchParams(url);
  const projectId = param.get('projectId');
  const moduleValue = param.get('moduleValue');

  const {
    moduleId,
    sectionListData,
    displaySectionListData,
    saveMultiSection,
    error,
    isLoading,
  } = useMultiSection(moduleValue);
  const moduleName = newRoutes.find((x) => x.id === moduleId)?.displayName;

  // console.log({ sectionListData });
  // console.log({ displaySectionListData });

  const customizeSection = (
    <MultiSectionSorter
      moduleId={moduleId}
      moduleValue={moduleValue}
      order={sectionListData}
      refresh={sectionSorterRefresher}
      refresher={setSectionSorterRefresher}
      modalLoading={modalLoading}
      isModalShow={isSettingModalShow}
      toggleModalShow={toggleSettingModalShow}
      saveMultiSection={saveMultiSection}
      activeSection={activeSectionInModal}
      clearActiveSection={() => setActiveSectionInModal(null)}
      getAccessibleModules={() =>
        dispatch(actions.getAccessibleModules(projectId))
      }
    />
  );

  const toggleEditModalBySection = (section) => () => {
    setActiveSectionInModal(section);
    toggleSettingModalShow(true);
  };

  const renderHub = ({ section = {}, ...rest }) => (
    <IntegrationHub
      section={section}
      {...rest}
      id={projectId}
      toggleEditModal={toggleEditModalBySection(section)}
      isMultiSection={true}
      multiSectionModuleName={moduleName}
    />
  );

  const changeOrderPropsValue = (sectionOrder, idV, prop, value) => {
    const orders = sectionOrder?.map((order) => {
      if (order.id === idV) {
        return { ...order, [prop]: value };
      }
      return order;
    });
    saveMultiSection(
      orders.map((obj) => {
        delete obj.identifier;
        Object.keys(obj).forEach((k) => obj[k] == null && delete obj[k]);
        return obj;
      }),
    );
    return orders;
  };

  const onSortEnd = async (sectionOrder) => {
    // saveMultiSection(sectionOrder.map((obj) => {
    //   delete obj.identifier;
    //   Object.keys(obj).forEach((k) => obj[k] == null && delete obj[k]);
    //   return obj;
    // }));
  };
  const saveLink = (section, link) => {
    const orders = sectionListData?.map((order) => {
      if (order.id === section.id) {
        return { ...order, link };
      }
      return order;
    });

    saveMultiSection(
      orders.map((obj) => {
        delete obj.identifier;
        Object.keys(obj).forEach((k) => obj[k] == null && delete obj[k]);
        return obj;
      }),
    );
  };

  if (isLoading) {
    return (
      <div className="page-wrapper integration-iframe-page multi-section-module">
        <Loading style={{ textAlign: 'center', marginTop: '10%' }} />
      </div>
    );
  }

  if (error) {
    return null;
  }

  return (
    <div className="page-wrapper integration-iframe-page multi-section-module">
      <div className="integration-iframe-head">
        <div className="multi-section-head">
          <span className="dd-back-btn" onClick={history.goBack}>
            <span className="appkiticon icon-left-chevron-fill a-font-12" />
            Back
          </span>
        </div>
        {isInternal && isContributor && (
          <div className="header-right">{customizeSection}</div>
        )}
      </div>

      {sectionListData?.map((section) => {
        if (!displaySectionListData.includes(section.id)) {
          return null;
        }
        return renderHub({
          section,
          sectionOrder: sectionListData,
          projectId,
          saveLink,
          changeOrderPropsValue,
          onSortEnd,
          saveMultiSection,
          refresh,
        });
      })}
    </div>
  );
}

export default memo(MultiSectionModule);
